import { render, staticRenderFns } from "./PageAdminUserNotifications.vue?vue&type=template&id=8aabc012"
import script from "./PageAdminUserNotifications.vue?vue&type=script&lang=js"
export * from "./PageAdminUserNotifications.vue?vue&type=script&lang=js"
import style0 from "./PageAdminUserNotifications.vue?vue&type=style&index=0&id=8aabc012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports